import { AppState, Auth0Provider, User } from "@auth0/auth0-react";
import React from "react";
import { useNavigate } from "react-router-dom";

// Only allow redirects back to a path on this app's own origin
const toSafeReturnPath = (returnTo: string | undefined): string => {
  try {
    const url = new URL(returnTo || "/", window.location.origin);
    if (url.origin === window.location.origin) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
  } catch {
    // Malformed URL; fall through to the safe default
  }
  return "/";
};

export const Auth0ProviderWithHistory: React.FC = ({ children }) => {
    const navigate = useNavigate();

  const onRedirectCallback = React.useCallback<
    (appState?: AppState, user?: User) => void
  >(
    (appState: AppState | undefined) => {
          navigate(toSafeReturnPath(appState?.returnTo || window.location.pathname));
    },
    [navigate]
  );

  return (
    <Auth0Provider
      audience={process.env.REACT_APP_AUTH0_AUDIENCE}
      cacheLocation="localstorage"
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || ""}
      domain={process.env.REACT_APP_AUTH0_DOMAIN || ""}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
